/**
 * WMS1101_R01(입고정보 조회) 품목 라벨 빌더
 *
 * WMS1100(LOT 조회)과 달리 LOT 없이 입고 상세(품목) 행 단위로 itemCd 바코드 라벨을 출력한다.
 */
import { ItemLabelPrintData } from "src/apis/itemLabelApi";
import { formatDate } from "src/utils/string/stringUtil";
import { WMS1101_R01DetailDto, WMS1101_R01HeaderDto } from "./Dto_WMS1101_R01";

/** 수량 포맷 (콤마 + 단위) */
const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return '';
	return `${qty.toLocaleString()}${unit || 'EA'}`;
};

/** 품목 1건 → ItemLabelPrintData 1건 변환 */
export const WMS1101_R01_buildItemLabelData = (
	header: WMS1101_R01HeaderDto,
	detail: WMS1101_R01DetailDto,
): ItemLabelPrintData => {
	if (!header) throw new Error('입고 정보를 찾을 수 없습니다.');
	if (!detail?.itemCd) throw new Error('품목코드를 찾을 수 없습니다.');
	if ((detail.qty || 0) <= 0) throw new Error('수량이 없어 라벨을 생성할 수 없습니다.');

	const transportDate = header.transportDt
		? formatDate(new Date(header.transportDt))
		: formatDate(new Date());

	return {
		itemCd: detail.itemCd || '',
		itemNm: detail.itemNm || '',
		itemSpec: detail.itemSpec || '',
		qty: formatQty(detail.qty, detail.unit || 'EA'),
		transportDate,
		storageLocation: header.warehouseNm || header.warehouseCd || '',
		customer: header.customNm || '',
		customerItemCd: detail.itemCd || '',
		labelType: '[자재입고]',
	};
};

/**
 * 선택된 상세 행(valueIndex) 목록으로 라벨 출력용 데이터 배열 생성
 * SearchSection 라벨 출력 버튼에서 사용 (WMS1100 LOT 선택 패턴과 동일)
 */
export const WMS1101_R01_buildItemLabelDataListFromSelectedDetails = (
	selectedValueIndexes: string[],
	detailList: WMS1101_R01DetailDto[],
	header: WMS1101_R01HeaderDto,
): ItemLabelPrintData[] => {
	if (!selectedValueIndexes?.length || !detailList?.length || !header) return [];

	const result: ItemLabelPrintData[] = [];
	for (const id of selectedValueIndexes) {
		const detail = detailList.find((d) => String(d.valueIndex) === String(id));
		if (!detail?.itemCd) {
			console.warn(`라벨 데이터 건너뜀: 상세 행을 찾을 수 없음 valueIndex=${id}`);
			continue;
		}
		try {
			result.push(WMS1101_R01_buildItemLabelData(header, detail));
		} catch (err) {
			console.error(`품목 라벨 데이터 생성 실패 itemCd=${detail.itemCd}`, err);
		}
	}
	return result;
};
